export default "__VITE_ASSET__DcUXO$z4__"